import { percentageSchema, priceSchema } from '~/utils/parsing';

export function formGrossPrice(netPrice: string, vatPercentage: string): string {
  const parsedNetPrice = priceSchema.parse(netPrice);
  const parsedVatFraction = percentageSchema.parse(vatPercentage);
  const vatAmount = parsedNetPrice.multipliedBy(parsedVatFraction).dividedBy(100);
  const grossPrice = parsedNetPrice.plus(vatAmount);
  const decimalPart = grossPrice.decimalPlaces(8).modulo(1);
  if (decimalPart.isEqualTo('0.00000001') || decimalPart.isEqualTo('0.99999999')) {
    return grossPrice.decimalPlaces(0).toFixed();
  }

  return grossPrice.decimalPlaces(8).toFixed();
}

export function formNetPrice(grossPrice: string, vatPercentage: string): string {
  const parsedGrossPrice = priceSchema.parse(grossPrice);
  const parsedVatFraction = percentageSchema.parse(vatPercentage).dividedBy(100);
  const netPrice = parsedGrossPrice.dividedBy(parsedVatFraction.plus(1));
  return netPrice.decimalPlaces(8).toFixed();
}

interface ManagementDataTypeOption {
  value: string;
  label: string;
  showText?: boolean;
  showNumber?: boolean;
  showData?: boolean;
}

export const managementDataTypeOption: ManagementDataTypeOption[] = [
  { value: 'ALI-COMP', label: 'ALI-COMP', showNumber: true },
  { value: 'AnniPreced', label: 'AnniPreced' },
  { value: 'F24', label: 'F24' },
  { value: 'INTENTO', label: 'INTENTO', showText: true, showData: true },
  { value: 'INVCONT', label: 'INVCONT' },
  { value: 'N.DOC.COMM', label: 'N.DOC.COMM', showText: true, showData: true },
  { value: 'NB1', label: 'NB1' },
  { value: 'NB2', label: 'NB2' },
  { value: 'NB3', label: 'NB3' },
  { value: 'NellAnno', label: 'NellAnno' },
  { value: 'NO-COMP', label: 'NO-COMP' },
  { value: 'OCC34BIS', label: 'OCC34BIS' },
  { value: 'TARGA', label: 'TARGA', showText: true },
];
